// Single currency: CLP (Chilean Pesos). Everything displays as $9.999.999.
// We keep `usePrice().format` so existing pages (SolutionPage, HomePage Offers,
// ProductDetailPage, ProductComparator) don't need to be re-wired — but the
// output is always CLP. No toggle, no UF.
import React, { createContext, useContext } from 'react';
import { formatCLP } from './format';

const PriceCtx = createContext({ format: formatCLP });
export const usePrice = () => useContext(PriceCtx);

export const PriceModeProvider = ({ children }) => (
  <PriceCtx.Provider value={{ format: formatCLP }}>
    {children}
  </PriceCtx.Provider>
);
